import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const features = [
  {
    icon: "fas fa-flask",
    title: "Science-Backed",
    desc: "Formulated by experts to support muscle growth, recovery, and overall wellness.",
  },
  {
    icon: "fas fa-seedling",
    title: "Clean Ingredients",
    desc: "No artificial fillers, banned substances, or hidden blends — only real, pure nutrition.",
  },
  {
    icon: "fas fa-vial",
    title: "Lab-Tested",
    desc: "Every batch undergoes rigorous third-party testing to ensure potency, purity, and safety.",
  },
  {
    icon: "fas fa-award",
    title: "Trusted Quality",
    desc: "Manufactured in certified facilities, ensuring consistent high-quality products you can rely on.",
  },
];

const WhyEvercore = () => {
  return (
    <>
    <Navbar/>
    <section className="why-evercore-section">
      <div className="why-evercore-container">
        {/* Section Title */}
        <h2 className="why-evercore-title">
          Why <span className="highlight-blue">EverCore?</span>
        </h2>

        {/* Section Description */}
        <p className="why-evercore-desc">
          At EverCore, we believe in clean, science-backed nutrition that fuels your body and supports your performance.
          From carefully sourced ingredients to lab-tested batches, our promise is simple: trustworthy, effective protein for
          everyday wellness and peak performance.
        </p>

        {/* Feature Cards */}
        <div className="why-evercore-cards">
          {features.map((f, i) => (
            <div key={i} className="why-card">
              <i className={f.icon}></i>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
   <Footer/>
    </>
  );
};

export default WhyEvercore;
